"use client"

import { Clock, History, User } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

interface VersionHistoryProps {
  fileId: string
}

// Mock version data
const versionData = [
  {
    id: "v3",
    version: "3.0",
    author: "Jane Smith",
    date: "2024-01-15",
    time: "14:30",
    changes: "Updated security requirements",
    isCurrent: true,
  },
  {
    id: "v2",
    version: "2.1",
    author: "John Doe",
    date: "2024-01-14",
    time: "09:15",
    changes: "Added API endpoint documentation",
    isCurrent: false,
  },
  {
    id: "v1",
    version: "2.0",
    author: "Jane Smith",
    date: "2024-01-13",
    time: "16:45",
    changes: "Initial authentication flow documentation",
    isCurrent: false,
  },
]

export function VersionHistory({ fileId: _fileId }: VersionHistoryProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <History className="size-5" />
          Version History
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {versionData.map((version) => (
            <div
              key={version.id}
              className="hover:bg-accent/50 rounded-lg border p-3 transition-colors"
            >
              <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="font-medium">v{version.version}</span>
                  {version.isCurrent && (
                    <Badge variant="default" className="text-xs">
                      Current
                    </Badge>
                  )}
                </div>
                <Button variant="ghost" size="sm">
                  View
                </Button>
              </div>

              <div className="text-muted-foreground space-y-1 text-sm">
                <div className="flex items-center gap-1">
                  <User className="size-3" />
                  <span>{version.author}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Clock className="size-3" />
                  <span>
                    {version.date} at {version.time}
                  </span>
                </div>
              </div>

              <p className="mt-2 text-sm">{version.changes}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
